import React, { useEffect } from "react";
import { connect } from "react-redux";
import queryParser from 'query-string-parser';
import * as actions from "../../../sc-core/Auth/store/authActions";
import config from "../../../../config/config";

const OpenIDLogin = props => {
    const { onOpenIDLogin, onGetLoginData } = props;
    useEffect(() => {

        const handleLogin = async () => {
            const urlOptions = queryParser.fromQuery(window.location.search);


            const currentUser = await onGetLoginData({ Token: urlOptions.Token });
            if (currentUser) {
                let res = await onOpenIDLogin(currentUser);
                if (res) {
                    window.location.href = config.web;
                }
            }
        };

        handleLogin();
    },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);
    return (
        <></>
    );
};



const mapDispatchToProps = dispatch => {
    return {
        onOpenIDLogin: params => dispatch(actions.openIDLogin(params)),
        onGetLoginData: params => dispatch(actions.getLoginData(params))
    };
};


export default connect(
    null,
    mapDispatchToProps
)(OpenIDLogin);
